import {useState, useCallback} from 'react'

import {StrengthTarget} from '../types'
import {formatISODateForDisplay} from '../utils/dateUtils'

export function useStrengthTargetListUtils(timezone: string) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [selectedTarget, setSelectedTarget] = useState<StrengthTarget | null>(null)
  const [commentDialogOpen, setCommentDialogOpen] = useState(false)
  const [selectedCommentTarget, setSelectedCommentTarget] = useState<StrengthTarget | null>(null)

  const handleMenuOpen = useCallback(
    (event: React.MouseEvent<HTMLElement>, target: StrengthTarget) => {
      setAnchorEl(event.currentTarget)
      setSelectedTarget(target)
    },
    []
  )

  const handleMenuClose = useCallback(() => {
    setAnchorEl(null)
    setSelectedTarget(null)
  }, [])

  const handleCommentClick = useCallback((target: StrengthTarget) => {
    setSelectedCommentTarget(target)
    setCommentDialogOpen(true)
  }, [])

  const handleCommentDialogClose = useCallback(() => {
    setCommentDialogOpen(false)
    setSelectedCommentTarget(null)
  }, [])

  const formatDate = useCallback(
    (isoDateString: string): string => {
      return formatISODateForDisplay(isoDateString, timezone)
    },
    [timezone]
  )

  const formatValidFrom = useCallback(
    (isoDateString: string): string => {
      return formatISODateForDisplay(isoDateString, timezone)
    },
    [timezone]
  )

  return {
    anchorEl,
    selectedTarget,
    commentDialogOpen,
    selectedCommentTarget,
    handleMenuOpen,
    handleMenuClose,
    handleCommentClick,
    handleCommentDialogClose,
    formatDate,
    formatValidFrom
  }
}
